/**
 * The popup serves two jobs from one component tree. `Create` starts from a map position with no
 * event behind it yet — no timestamps, no status drawer, and the footer commits with `Create event`
 * instead of `Save changes`.
 */
export enum DialogEventMode {
  Create = 'create',
  Edit = 'edit',
}
